import { render, staticRenderFns } from "./surface-post-reaction-new.vue?vue&type=template&id=6d76bee8&"
import script from "./surface-post-reaction-new.vue?vue&type=script&lang=ts&"
export * from "./surface-post-reaction-new.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports